import styled from 'styled-components';

const StyledWrapper = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	transform: translateY(20px);
	opacity: 0;
	transition:
		transform 0.5s ease 0.1s,
		opacity 0.5s ease 0.1s;
`;

const StyledPanelControlsContainer = styled.div`
	position: absolute;
	bottom: 60px;
	left: 50%;
	transform: translateX(-50%);
	width: max-content;
`;

export { StyledWrapper, StyledPanelControlsContainer };
